import { INITIAL_STATE } from '../initialState';
import {
  updateChildCommentById,
  updateCommentById
} from '../commentsUpdaterFunctions';
import { updateMentionsBasedOnComments } from '../../../../utils/mentioning/mentionFormatters';

// Comment updating functions.
// Allows logic to be shared
// for both parent and children comments
const setTranslationRequested = (comment) => ({
  ...comment,
  translation: {
    isTranslated: false,
    loading: true,
    error: false
  }
});

const setTranslationSuccessful = (comment, translatedComment) => ({
  ...comment,
  body: translatedComment,
  translation: {
    isTranslated: true,
    loading: false,
    error: false,
    previousComment: comment.body
  }
});

const setTranslationFailed = (comment) => ({
  ...comment,
  translation: {
    isTranslated: false,
    loading: false,
    error: true
  }
});

// Swaps the translated/untranslated commments.
// For use after the comment has been translated
// by the API.
const toggleTranslatedComment = (comment) => ({
  ...comment,
  body: comment.translation.previousComment,
  translation: {
    ...comment.translation,
    isTranslated: !comment.translation.isTranslated,
    previousComment: comment.body
  }
});

// Reducer functions:

export const translateParentRequest = (state = INITIAL_STATE, action) => {
  const {
    payload: { commentId }
  } = action;

  const { comments } = state;
  return {
    ...state,
    comments: updateCommentById(comments, commentId, setTranslationRequested)
  };
};

export const translateParentSuccess = (state = INITIAL_STATE, action) => {
  const {
    payload: { commentId, translatedComment }
  } = action;

  const { comments } = state;

  return {
    ...state,
    comments: updateCommentById(
      comments,
      commentId,
      updateMentionsBasedOnComments(setTranslationSuccessful),
      translatedComment
    )
  };
};

export const translateParentFailure = (state = INITIAL_STATE, action) => {
  const {
    payload: { commentId }
  } = action;

  const { comments } = state;

  return {
    ...state,
    comments: updateCommentById(comments, commentId, setTranslationFailed)
  };
};

export const translateChildRequest = (state = INITIAL_STATE, action) => {
  const {
    payload: { commentId, rootId }
  } = action;

  const { comments } = state;
  return {
    ...state,
    comments: updateChildCommentById(
      comments,
      rootId,
      commentId,
      setTranslationRequested
    )
  };
};

export const translateChildSuccess = (state = INITIAL_STATE, action) => {
  const {
    payload: { commentId, rootId, translatedComment }
  } = action;

  const { comments } = state;

  return {
    ...state,
    comments: updateChildCommentById(
      comments,
      rootId,
      commentId,
      updateMentionsBasedOnComments(setTranslationSuccessful),
      translatedComment
    )
  };
};

export const translateChildFailure = (state = INITIAL_STATE, action) => {
  const {
    payload: { commentId, rootId }
  } = action;

  const { comments } = state;

  return {
    ...state,
    comments: updateChildCommentById(
      comments,
      rootId,
      commentId,
      setTranslationFailed
    )
  };
};

export const toggleParentTranslation = (state = INITIAL_STATE, action) => {
  const {
    payload: { commentId }
  } = action;

  const { comments } = state;

  return {
    ...state,
    comments: updateCommentById(comments, commentId, toggleTranslatedComment)
  };
};

export const toggleChildTranslation = (state = INITIAL_STATE, action) => {
  const {
    payload: { commentId, rootId }
  } = action;

  const { comments } = state;

  return {
    ...state,
    comments: updateChildCommentById(
      comments,
      rootId,
      commentId,
      toggleTranslatedComment
    )
  };
};
